import { IconName, TradeSettleStatusEnum } from '@talos/kyoko';
import type { DefaultTheme } from 'styled-components';

type LPTradeStatusMappingWithColor = {
  icon: IconName | null;
  color: string;
  description: string;
  label: string;
};

/**
 * Get trade settle status mapping with icons, colors, and descriptions
 * Based on the trade settle status legend showing overall status of a trade
 */
export function getLPTradeStatusMapping(
  status: TradeSettleStatusEnum,
  theme: DefaultTheme
): LPTradeStatusMappingWithColor | null {
  switch (status) {
    case TradeSettleStatusEnum.Unsettled:
      return {
        icon: IconName.Clock,
        color: theme.colors.gray['090'],
        description: '',
        label: 'Unsettled',
      };
    case TradeSettleStatusEnum.Canceled:
      return {
        icon: IconName.CloseCircleSolid,
        color: theme.colors.gray['090'],
        description: '',
        label: 'Canceled',
      };
    case TradeSettleStatusEnum.DueSettled:
    case TradeSettleStatusEnum.ProceedsSettled:
      return {
        icon: IconName.ChartPie050,
        color: theme.colors.blue.default,
        description: '',
        label: 'In Progress',
      };
    case TradeSettleStatusEnum.Settled:
      return {
        icon: IconName.CheckCircleSolid,
        color: theme.colors.green.default,
        description: '',
        label: 'Settled',
      };
    default:
      return null;
  }
}
